import React from 'react';
import DefaultTabs, { TabsProps } from '../../../Templates/DefaultTemplate/Components/Tabs/Tabs';
import ModernTabs from '../../../Templates/ModernTemplate/Components/ServicesTabs/ServicesTabs';
import { TemplatesList } from '../../../../enums/TemplatesList';

interface Props extends TabsProps {
  template: TemplatesList;
}

const ServicesTabs = (props: Props) => {
  if (props.template === TemplatesList.MODERN) {
    return <ModernTabs {...props}>{props.children}</ModernTabs>;
  }
  return <DefaultTabs {...props}>{props.children}</DefaultTabs>;
};

export default ServicesTabs;
